import { Component } from "@angular/core";
import { RouterService } from "app/core/navigation";
import { TextIdModel } from "app/shared/models/text-id.model";
import { TeacherService } from "app/teacher/services/teacher.service";
import { environment } from "env/environment";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    selector: 'kh-generic-pick-class-modal',
    templateUrl: './generic-pick-class-modal.component.html',
    styleUrls: ['./generic-pick-class-modal.component.less'],
    standalone: false
})

  export class GenericPickClassModalComponent {

    public classes:TextIdModel[] = [];
    public selectedClassId = "";

    constructor(private readonly bsModalRef: BsModalRef, private readonly teacherService: TeacherService,  private readonly router: RouterService) {}

    public selectClass(classId: string) {
        if (classId) {           
            this.selectedClassId = classId;
            this.teacherService.activeClassId = classId;
            this.bsModalRef.hide();
        }
    }

    public getClassName = (c: TextIdModel) => c.text;

    public getClassId = (c: TextIdModel) => c.id;
  }